const EXT_TO_MIME: Record<string, string> = {
	".pdf": "application/pdf",
	".jpg": "image/jpeg",
	".jpeg": "image/jpeg",
	".png": "image/png",
	".xls": "application/vnd.ms-excel",
	".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	".csv": "text/csv",
};

type Accept = Record<string, string[]>;

export const parseAcceptedFiles = (
	acceptedFiles: string | Accept | undefined
): Accept | undefined => {
	if (!acceptedFiles) {
		return undefined;
	}
	if (typeof acceptedFiles === "object") {
		return acceptedFiles;
	}

	const result: Accept = {};
	const exts = acceptedFiles
		.split(",")
		.map((e) => e.trim().toLowerCase())
		.filter(Boolean);

	for (const ext of exts) {
		const normalized = ext.startsWith(".") ? ext : `.${ext}`;
		const mime = EXT_TO_MIME[normalized];
		if (!mime) {
			continue;
		}
		if (!result[mime]) {
			result[mime] = [];
		}
		if (!result[mime].includes(normalized)) {
			result[mime].push(normalized);
		}
	}

	return Object.keys(result).length > 0 ? result : undefined;
};
